<template>
  <div>
    <h1 class="page-header">{{ $t('payMonthlyCompensate.pageTitle') }}</h1>
    <div>
      <ts-card>
        <ts-card-wrapper>
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6 d-flex justify-content-start">
              <ts-button color="info" outline @click="showForm()">{{ $t('addNew') }}</ts-button>
              <b-dropdown
                :disabled="loadingPreData"
                text="Import"
                variant="outline-default"
                class="ml-2"
              >
                <b-dropdown-item
                  href="#"
                  v-for="(item, index) in itemCompensates"
                  @click="showFormImportCustomCompensate(item)"
                  :key="index"
                >{{ item.compensate_item }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <div class="col-sm-12 col-md-2 col-lg-2">
              <ts-date-picker-input v-model="cycle_year" format="YYYY"></ts-date-picker-input>
            </div>
            <div class="col-sm-12 col-md-2 col-lg-2">
              <ts-date-picker-input v-model="cycle_month" format="MM"></ts-date-picker-input>
            </div>
            <div class="col-sm-12 col-md-2 col-lg-2">
              <ts-input style="width:100%" v-model="search" :placeholder="$t('search')" />
            </div>
          </div>
        </ts-card-wrapper>
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td
              class="ts-whitespace-no-wrap"
            >{{ record.employee ? record.employee.employee_name_en : '' }}</td>
            <td
              class="ts-whitespace-no-wrap"
            >{{ record.compensate_item ? record.compensate_item.compensate_item : '' }}</td>
            <td class="ts-whitespace-no-wrap text-center">{{ record.compensate }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.description }}</td>
            <td class="text-center">
              <a
                href="#"
                v-tooltip="$t('tooltip.edit')"
                class="text-primary mr-2"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('tooltip.delete')"
                class="text-danger"
                @click.prevent="destroy(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
        <div class="d-flex justify-content-end p-15">
          <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
        </div>
      </ts-card>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './form.vue'
import FormImportCustomCompensate from './form-import-custom-compensate.vue'

export default {
  name: 'pay-monthly-compensate',
  data() {
    return {
      loading: false,
      loadingPreData: false
    }
  },
  created() {
    this.fetchData()
    this.fetchResourceBeforeCreate()
  },
  computed: {
    ...mapState('hr/payMonthlyCompensate', ['resources', 'pagination', 'itemCompensates']),
    search: {
      get() {
        return this.$store.state.hr.payMonthlyCompensate.search
      },
      set(newValue) {
        this.$store.commit('hr/payMonthlyCompensate/SET_SEARCH', newValue)
        this.$store.commit('hr/payMonthlyCompensate/RESET_CURRENT_PAGE')
      }
    },
    cycle_month: {
      get() {
        return this.$store.state.hr.payMonthlyCompensate.cycle_month
      },
      set(newValue) {
        this.$store.commit('hr/payMonthlyCompensate/SET_CYCLE_MONTH', newValue)
      }
    },
    cycle_year: {
      get() {
        return this.$store.state.hr.payMonthlyCompensate.cycle_year
      },
      set(newValue) {
        this.$store.commit('hr/payMonthlyCompensate/SET_CYCLE_YEAR', newValue)
      }
    },
    columns() {
      return [
        {
          name: this.$t('payMonthlyCompensate.employeeId'),
          sortKey: 'employee.employee_name_en'
        },
        {
          name: this.$t('payMonthlyCompensate.compensateId'),
          sortKey: 'compensate_item.compensate_item'
        },
        {
          name: this.$t('payMonthlyCompensate.compensate'),
          sortKey: 'compensate',
          style: 'text-align:center;'
        },
        {
          name: this.$t('payMonthlyCompensate.description'),
          sortKey: 'description'
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchResourceBeforeCreate() {
      this.loadingPreData = true
      this.$store
        .dispatch('hr/payMonthlyCompensate/dataBeforeCreate')
        .then(() => {
          this.loadingPreData = false
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('hr/payMonthlyCompensate/fetch', { include: 'employee,compensate_item', ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.showForm(record)
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('hr/payMonthlyCompensate/destroy', record.record_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    showForm(editData) {
      this.$modal.show(
        FormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '400px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    showFormImportCustomCompensate(data) {
      this.$modal.show(
        FormImportCustomCompensate,
        {
          data: data
        },
        {
          height: 'auto',
          width: '50%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    cycle_year: function() {
      this.fetchData()
    },
    cycle_month: function() {
      this.fetchData()
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/payMonthlyCompensate/RESET_STATE')
    next()
  }
}
</script>
